
const i18nData = $("#pageAttributes").data('custom_strings') || {};

const stripHTML = (html) => {
  let tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

class MinNotes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            noteText: ''
        }
    }
    render() {
        const {notesData = [], addNoteHandler, deleteNoteHandler, plainText = false} = this.props;
        const {noteText} = this.state;
        const onChange = (text) => {
          if(plainText) return stripHTML(text);
          return text;
        }
        return (
            <div className="preview-candidate-notes">
                  <div className="candidate-remarks">
                    <h4>{i18n_terms('comments', i18nData)}</h4>
                    {notesData && (
                      <div className="note-list">
                        <ul>
                          {notesData.map((note, index) => {
                            return (
                              <li key={index}>
                                <div className="ic-note-wrapper">
                                  <span id="note-text" className="" >{moment(note.time).format('YYYY-MM-DD')}&nbsp;<strong>{note.userName}</strong></span><br></br>
                                  <span id="note-text" dangerouslySetInnerHTML={{ __html: note.text}}></span>
                                  {note.is_current_user &&
                                    <button
                                      className="ic-delete-note"
                                      onClick={() => deleteNoteHandler(note)}
                                    >
                                      <span className="icon-svg-trash-01"></span>
                                    </button>
                                  }
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                    <div className="candidate-remarks-input notesInput">
                      <span
                        role="textbox"
                        id="noteTextField"
                        name="note"
                        className=""
                        onBlur={e => this.setState({noteText: onChange(e.target.innerHTML)})}
                        contentEditable
                        suppressContentEditableWarning
                      >{noteText}</span>
                      <button
                        type="button"
                        onClick={() => {
                            addNoteHandler(noteText)
                            $('#noteTextField').html("")
                            this.setState({
                                noteText: ''
                            })
                        }}
                        id="note-btn"
                        className=""
                      >
                        {i18n_terms('comment', i18nData)}
                      </button>
                    </div>
                  </div>
                </div>
        );
    }
}

window.MinNotes = MinNotes;
